import { render, staticRenderFns } from "./SaveEditClass.vue?vue&type=template&id=cf1b965a&scoped=true&"
import script from "./SaveEditClass.vue?vue&type=script&lang=js&"
export * from "./SaveEditClass.vue?vue&type=script&lang=js&"
import style0 from "./SaveEditClass.vue?vue&type=style&index=0&id=cf1b965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1b965a",
  null
  
)

export default component.exports